import { useCallback, useEffect } from "react";

const usePreventNavigation = ({
  enabled,
  message,
}: {
  enabled: boolean;
  message: string;
}) => {
  const beforeUnloadListener = useCallback(
    (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
      return event;
    },
    [message]
  );

  useEffect(() => {
    if (enabled) {
      addEventListener("beforeunload", beforeUnloadListener, { capture: true });
    } else {
      removeEventListener("beforeunload", beforeUnloadListener, {
        capture: true,
      });
    }

    return () => {
      removeEventListener("beforeunload", beforeUnloadListener, {
        capture: true,
      });
    };
  }, [beforeUnloadListener, enabled]);
};

export default usePreventNavigation;
